// extracted by mini-css-extract-plugin
export default {"moderation-flag":"moderation-flag__VRIpX","title":"title__ycdsG","actions":"actions__3NObi","check-icon":"check-icon__2GjE4"};